import { cn } from '@utils/cn'

export default function Badge({ children, variant = 'primary', className }) {
  const variants = {
    primary:
      'bg-primary-100 text-primary-800 dark:bg-primary-900 dark:text-primary-100',
    secondary:
      'bg-secondary-100 text-secondary-800 dark:bg-secondary-900 dark:text-secondary-100',
    success: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100',
    warning: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-100',
    danger: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-100',
    info: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-100',
  }

  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        variants[variant],
        className
      )}
    >
      {children}
    </span>
  )
}
